import Country from '~/Api/Country/Country';

const EuropeIds = new Set(['europe', 'eu-eaa', 'eu-5', 'eu-cee']);

export default class Region {
	id: string;

	title: string;

	countries: Country[];

	subRegions: Region[];

	constructor(id: string, title: string, countries: Country[], subRegions: Region[]) {
		this.id = id;
		this.title = title;
		this.countries = countries;
		this.subRegions = subRegions;
	}

	get isInEurope(): boolean {
		return EuropeIds.has(this.id);
	}
}
